import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { handleError } from "src/Common/function";
import RoleService from "src/Services/API/role.service";

/**
 * Create / edit role modal. When `role` is provided it edits that role;
 * otherwise it creates a new one. Calls `onSaved` on success.
 */
function CreateRoleModal({ shown, role, onClose, onSaved }) {
  const isEdit = !!role;
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (shown) {
      setName(role?.name ?? "");
      setDescription(role?.description ?? "");
    }
  }, [shown, role]);

  if (!shown) return null;

  const save = () => {
    if (!name.trim()) {
      toast("Role name is required");
      return;
    }
    setIsSaving(true);
    const payload = { name: name.trim(), description };
    const req = isEdit ? RoleService.update(role.id, payload) : RoleService.create(payload);
    req
      .then(() => {
        toast(isEdit ? "Role updated" : "Role created");
        onSaved?.();
        onClose?.();
      })
      .catch(handleError)
      .finally(() => setIsSaving(false));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div
        className="bg-white rounded-[12px] w-[440px] max-w-[92vw] p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-[18px] font-OpenSansBold text-[#1A2332] mb-4">
          {isEdit ? "Edit Role" : "Create Role"}
        </h2>

        <label className="block text-[13px] font-OpenSansSemiBold text-[#404A6E] mb-1">Role Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={isEdit && role?.name === "Super Admin"}
          placeholder="e.g. Regional Manager"
          className="w-full px-3 py-2 mb-4 rounded-[8px] border border-[#E5E8F3] text-[14px] font-OpenSansRegular outline-none focus:border-[#0058E5] disabled:bg-[#F8F9FE]"
        />

        <label className="block text-[13px] font-OpenSansSemiBold text-[#404A6E] mb-1">Description</label>
        <input
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Short description"
          className="w-full px-3 py-2 mb-6 rounded-[8px] border border-[#E5E8F3] text-[14px] font-OpenSansRegular outline-none focus:border-[#0058E5]"
        />

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-[8px] border border-[#E5E8F3] text-[14px] font-OpenSansSemiBold text-[#404A6E] hover:bg-[#F8F9FE]"
          >
            Cancel
          </button>
          <button
            onClick={save}
            disabled={isSaving}
            className="px-4 py-2 rounded-[8px] bg-[#0058E5] text-white text-[14px] font-OpenSansSemiBold hover:bg-[#0048bd] disabled:opacity-60"
          >
            {isSaving ? "Saving…" : isEdit ? "Save" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateRoleModal;
